"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Dots = function Dots() {
  return function (input, param) {
    if (angular.isDefined(input) && !!input) {
      if (param) {
        return input.substring(0, parseInt(param)) + " ...";
      }
      return input.substring(0, 100) + " ...";
    }
  };
};
exports.default = Dots;


// WEBPACK FOOTER //
// ./client/app/common/filters/dotsFilter/dots.filter.js